import React, { useEffect, useState } from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Dropdown, Menu } from 'antd';
import '../assets/style/client-workspace.css';
import '../assets/style/workspace-components.css';
import '../assets/style/streaming-workspace.css';
import '../assets/style/studio-preparation.css';

export function ClientSurface() {
  useEffect(() => {
    const count = Number(document.body.dataset.clientSurfaces || 0) + 1;
    document.body.dataset.clientSurfaces = count;
    document.body.setAttribute('data-client-ui', '');
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const sync = () => {
      let choice = 'system';
      try { choice = localStorage.getItem('viblica-appearance') || 'system'; } catch (_) {}
      document.body.setAttribute('data-client-theme', choice === 'system' ? (query.matches ? 'dark' : 'light') : choice);
    };
    sync();
    query.addListener(sync);
    window.addEventListener('viblica-appearance', sync);
    window.addEventListener('storage', sync);
    return () => {
      query.removeListener(sync);
      window.removeEventListener('viblica-appearance', sync);
      window.removeEventListener('storage', sync);
      const remaining = Math.max(0, Number(document.body.dataset.clientSurfaces) - 1);
      document.body.dataset.clientSurfaces = remaining;
      if (!remaining) document.body.removeAttribute('data-client-ui');
    };
  }, []);
  return null;
}

export default function ClientAppearance({ compact = false }) {
  const [choice, setChoice] = useState(() => {
    try { return localStorage.getItem('viblica-appearance') || 'system'; } catch (_) { return 'system'; }
  });
  useEffect(() => {
    const read = () => {
      try { setChoice(localStorage.getItem('viblica-appearance') || 'system'); } catch (_) {}
    };
    window.addEventListener('viblica-appearance', read);
    window.addEventListener('storage', read);
    return () => { window.removeEventListener('viblica-appearance', read); window.removeEventListener('storage', read); };
  }, []);
  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => document.body.setAttribute('data-client-theme', choice === 'system' ? (query.matches ? 'dark' : 'light') : choice);
    apply();
    query.addListener(apply);
    try { localStorage.setItem('viblica-appearance', choice); window.dispatchEvent(new Event('viblica-appearance')); } catch (_) {}
    return () => query.removeListener(apply);
  }, [choice]);
  if (compact) {
    const CurrentIcon = {light:Sun,dark:Moon,system:Monitor}[choice] || Monitor;
    const menu = <Menu className="client-theme-menu" selectedKeys={[choice]} onClick={({key}) => setChoice(key)}>
      {[['light', Sun, 'Light'], ['dark', Moon, 'Dark'], ['system', Monitor, 'System']].map(([value, Icon, label]) => <Menu.Item key={value}><span className="client-theme-option"><Icon size={16}/><span>{label}</span></span></Menu.Item>)}
    </Menu>;
    return <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft"><button type="button" className="client-theme-trigger" aria-label="Change appearance" aria-haspopup="menu" title="Appearance"><CurrentIcon size={17}/></button></Dropdown>;
  }
  return <div className="client-appearance" role="group" aria-label="Appearance">
    {[['light', Sun], ['dark', Moon], ['system', Monitor]].map(([value, Icon]) =>
      <button key={value} type="button" aria-label={`${value} appearance`} title={`${value} appearance`} aria-pressed={choice === value} onClick={() => setChoice(value)}><Icon size={17} /></button>
    )}
  </div>;
}
